import React from 'react';
import { useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';


import "./stepsOfBuy.css"




 
const StepsOfBuy = (props) => {
 let [steps, setSteps] = useState(
    {
        one:false,
        two:false, 
        three: false
    }
 )
let choose1 = 0;

function checkStepsOfBuyProcess(dependenceBetweenStepsAndChosen){

    switch (dependenceBetweenStepsAndChosen) {
        case true:
             if(props.steps < 8){
                choose1 = 1
            }else if(props.steps == 8){
                choose1 = 2
            }
            break;
    
        default:
     
             if(props.steps < 8){
                choose1 = 1
            }else if(props.steps == 8){
                choose1 = 2
            }
            break;
    }
   
}

checkStepsOfBuyProcess(props.lvl == undefined)
    return <> 
        <div className='stepsNavigation'>
            {props.stepsList.map((step,index)=>{
                return  <div key={index} className={choose1 == index?'stepsNavigation_boxItem choosenItem':'stepsNavigation_boxItem'}>
                {choose1 > index&&window.innerWidth >795?
                <svg width="13" height="24" viewBox="0 0 13 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10.8565 0.827979C10.5646 0.837715 10.2881 0.960929 10.0857 1.1713C7.93795 3.32362 6.2976 5.12136 4.30447 7.15574L2.1811 5.3618V5.36192C1.95357 5.1695 1.6588 5.0755 1.36186 5.10077C1.06501 5.12604 0.790303 5.26849 0.598586 5.49649C0.406756 5.7246 0.313678 6.01959 0.339757 6.31644C0.365837 6.61329 0.508985 6.88753 0.737553 7.07877L3.65268 9.54545V9.54533C3.86723 9.72604 4.1416 9.81981 4.42175 9.8081C4.70202 9.79651 4.96767 9.68025 5.16636 9.48229C7.58147 7.06199 9.30069 5.12898 11.6695 2.75514V2.75526C11.8877 2.5443 12.0112 2.25393 12.0115 1.9505C12.012 1.64694 11.8894 1.35635 11.6717 1.14482C11.454 0.93328 11.1599 0.819006 10.8566 0.828146L10.8565 0.827979Z" fill="#CC0033"/>
                </svg>:""}
                <p>{step}</p>
            </div>
            })}
            
        </div>
       
    </>;
    }

export default StepsOfBuy;
